import { REDIRECT_LINK_PERMISSIONS } from "../api/permissions";

export const handleLoginSuccess = (data, history) => {
  localStorage.setItem("token", data.token);
  localStorage.setItem("email", data.admin.email);
  localStorage.setItem("user", JSON.stringify(data.admin));

  let perms = data.admin.role?.Permissions.map((p) => p.token) ?? [];
  localStorage.setItem("permissions", JSON.stringify(perms));

  const filteredPermissions = perms.filter(
    (p) => p in REDIRECT_LINK_PERMISSIONS
  );

  const firstViewPermission = filteredPermissions.find((p) => /view$/.test(p));

  const redirectLink =
    REDIRECT_LINK_PERMISSIONS[firstViewPermission] || "/companies";

  history.push(redirectLink);
};
